import { FOOD_TYPE_LABELS } from '../../../constants';

export const MENU_TYPE_OPTIONS = [
	{
		label: FOOD_TYPE_LABELS.any,
		value: 'any',
		description: 'Flexible menu that can include any mix of dishes.',
	},
	{
		label: FOOD_TYPE_LABELS.seafood,
		value: 'seafood',
		description: 'Focused on fish and shellfish-based dishes.',
	},
	{
		label: FOOD_TYPE_LABELS.vegetarian,
		value: 'vegetarian',
		description: 'Plant-focused menu with no meat or seafood.',
	},
	{
		label: FOOD_TYPE_LABELS.vegan,
		value: 'vegan',
		description: 'Fully plant-based menu with no animal products.',
	},
	{
		label: FOOD_TYPE_LABELS.meat_poultry,
		value: 'meat_poultry',
		description: 'Includes dishes with meat and poultry options.',
	},
];

export const MENU_NAME_EXAMPLES_TEXT = 'e.g. "My Lunch Menu", "To Share", "Dessert Delights"';

